import { render, staticRenderFns } from "./AddToListDialog.vue?vue&type=template&id=b305d0b8"
import script from "./AddToListDialog.ts?vue&type=script&lang=ts&external"
export * from "./AddToListDialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports